import { render, staticRenderFns } from "./RefundLuggagesPopoverContent.vue?vue&type=template&id=1f42c6e8&scoped=true&"
import script from "./RefundLuggagesPopoverContent.vue?vue&type=script&lang=js&"
export * from "./RefundLuggagesPopoverContent.vue?vue&type=script&lang=js&"
import style0 from "./RefundLuggagesPopoverContent.vue?vue&type=style&index=0&id=1f42c6e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42c6e8",
  null
  
)

export default component.exports